import fetch from "isomorphic-unfetch";

var BASE_URL;
const REMOTE_URL = "https://api.doer.app";
const LOCAL_URL = "http://localhost:4242";

if (window.location.href.indexOf("localhost") >=0) {
    BASE_URL = LOCAL_URL;
} else {
    BASE_URL = REMOTE_URL;
}

const APPLICATION_JSON_CONTENT_TYPE = "application/json";

export default {

    token: null,
    user: null,

    setUserAndToken(user, token) {
        this.token = token;
        this.user = user;
    },

    createHeaders() {
        var headers = {
            "Content-Type": APPLICATION_JSON_CONTENT_TYPE
        };
        
        if (window && window.localStorage.token) {
            headers["x-user-token"] = window.localStorage.token;
        }

        return headers;
    },

    async post(url, body) {
        return await this.runRequest("POST", url, body);
    },

    async delete(url, body) {
        return await this.runRequest("DELETE", url, body);
    },

    async patch(url, body) {
        return await this.runRequest("PATCH", url, body);
    },

    async get(url) {
        return await this.runRequest("GET", url);
    },

    async runRequest(method, url, body) {
        try {
            const res = await fetch(`${BASE_URL}${url}`, {
                method: method,
                headers: this.createHeaders(),
                body: body ? JSON.stringify(body) : undefined
            });

            // Get data back
            const data = await res.json();

            // Check data for errors
            if (data.errors) {
                throw Error(data.errors[0].message);
            }

            if (!data.data) {
                return data;
            }

            return data.data;

        } catch (e) {
            console.log(e);
            throw Error("An unxpected error occurred");
        }
    
    },

    async query(query, projectId) {
        var res;

        var baseUrlToUse = "";

        if (projectId) {
            baseUrlToUse += `${BASE_URL}/${projectId}/graphql`;
        } else {
            baseUrlToUse += `${BASE_URL}/graph`;
        }

        try {
            res = await fetch(baseUrlToUse, {
                method: "post",
                headers: this.createHeaders(),
                body: JSON.stringify({query: query})
            });

        } catch (e) {
            console.log(e);
            throw Error("An unxpected error occurred");
        }
    
        // Get data back
        const data = await res.json();

        // Check data for errors
        if (data.errors) {
            throw Error(data.errors[0].message);
        }

        if (!data.data) {
            return data;
        }

        return data.data;  
    },
    
    stringifyNoQuotes(obj) {
        var jsonStr = JSON.stringify(obj);
        // eslint-disable-next-line
        return jsonStr.replace(/\"([^(\")"]+)\":/g,"$1:"); 
    }
};


// WEBPACK FOOTER //
// ./src/services/HttpServices.js